'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.tutorial.add', [])
  .controller('TutorialAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tutorial/add/index.js